import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
import FactCheckIcon from '@mui/icons-material/FactCheck'
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer'
import LockIcon from '@mui/icons-material/Lock'
import PendingActionsIcon from '@mui/icons-material/PendingActions'
import GroupIcon from '@mui/icons-material/Group'
import AssignmentIcon from '@mui/icons-material/Assignment'
import LogoutIcon from '@mui/icons-material/Logout'
import EditIcon from '@mui/icons-material/Edit'
import RemoveIcon from '@mui/icons-material/RemoveCircle'
import MenuIcon from '@mui/icons-material/Menu'
import CalendarMonth from '@mui/icons-material/CalendarMonth'

export const HomeIcon = (props: SvgIconProps)  => {

  return (
    <SvgIcon {...props}>
      <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
    </SvgIcon>
  );

}

export const ListIcon = ()  => {

  return ( <FactCheckIcon /> );

}

export const BetIcon = ()  => {

  return ( <SportsSoccerIcon /> );

}

export const ResetPassIcon = ()  => {

  return ( <LockIcon /> );

}

export const ResultIcon = ()  => {

  return ( <PendingActionsIcon /> );

}

export const UsersIcon = ()  => {

  return ( <GroupIcon /> );

}

export const DocIcon = ()  => {

  return ( <AssignmentIcon /> );

}

export const OutIcon = ()  => {

  return ( <LogoutIcon /> );

}

export const EditsIcon = ()  => {

  return ( <EditIcon /> );

}

export const InativeIcon = ()  => {

  return ( <RemoveIcon /> );

}

export const MenusIcon = () => {

  return ( <MenuIcon style={{fontSize:'2.5rem', color:'#FFF'}} /> );

}

export const CalendarIcon = () => {

  return ( <CalendarMonth style={{fontSize:'2.5rem', color:'#FFF'}} /> );

}

